import type { FixedNumber } from "@ethersproject/bignumber";
import type { SupTransactionType, Networkish } from "@/types";
import React from "react";

import { SupIconButton, SupLoader, SupTag, SupText } from "@repo/core-ui";
import config from "@/../config/dapp.config";
import useChainInfo from "@/hooks/useChainInfo";
import { SupChevronDown } from "@repo/core-ui";
import { formatCurrencyCompact } from "@/utils";

interface Web3CommonSelectedTokenProps {
  selectedBalance: {
    icon?: string;
    logoURI?: string;
    symbol: string;
    chainId: Networkish | number;
    amountFixedNumber?: FixedNumber;
    amountInFiat?: string;
  };
  onChange: () => void;
  type?: SupTransactionType;
}

export default function Web3CommonSelectedToken({ selectedBalance, onChange, type = "deposit" }: Web3CommonSelectedTokenProps) {
  const { isLoading, data: chainData } = useChainInfo(selectedBalance.chainId);

  return (
    <div className="sup-asset-selector">
      <SupText variant="caption" className="mb-1 h-5 leading-5">
        {type === "deposit" ? "Funding" : "target"} token
      </SupText>
      <div
        onClick={onChange}
        className="group flex h-[52px] w-full cursor-pointer items-center justify-between border-[0.5px] border-neutral-800 bg-primary-50 py-2 pl-2 pr-4 lg:hover:border-primary-300/20 lg:hover:bg-primary-300/20"
      >
        <div className="sup-tx-token flex items-center">
          {isLoading ? (
            <SupLoader isSmall />
          ) : (
            <SupTag assetIcon={selectedBalance.icon || selectedBalance.logoURI} assetLabel={selectedBalance.symbol} chainIcon={chainData?.icon} chainLabel={chainData?.name} />
          )}
        </div>
        <div className="inline-flex h-9 items-center justify-end gap-2">
          {type === "deposit" && selectedBalance.amountInFiat && selectedBalance.amountFixedNumber && (
            <div className="inline-flex h-full flex-col items-end justify-center gap-1">
              <div className="text-base font-normal uppercase leading-none tracking-wide text-neutral-700">
                {selectedBalance.amountFixedNumber.round(config.decimalsBigRoundingLimit).toString()}
              </div>
              <div className="inline-flex items-center justify-start gap-1">
                <div className="text-xs font-normal leading-3 tracking-wide text-neutral-700">
                  {formatCurrencyCompact(selectedBalance.amountInFiat ? parseFloat(selectedBalance.amountInFiat as string) : 0)}
                </div>
              </div>
            </div>
          )}
          <SupIconButton className="txt-16_24 flex flex-nowrap items-center space-x-[4px] whitespace-nowrap">
            <SupChevronDown className="h-5 w-5 stroke-[0.5px] transition-transform duration-200 group-hover:rotate-180" />
          </SupIconButton>
        </div>
      </div>
    </div>
  );
}
